module.exports = __webpack_public_path__ + "static/media/santa_katarina_thumb.529c4ddb.webp";